import type { ReceiverId } from '../../../generated-types';
import { updateReceiver } from '../../../services/receiverService';
import { ReceiverDetailsState } from './state';

type ReceiverDetailsWithId = {
    receiverId: ReceiverId;
} & ReceiverDetailsState;

export default (state: ReceiverDetailsWithId) => {
    return updateReceiver(state.receiverId, {
        accountNumber: { value: state.accountNumber },
        name: state.accountName,
        deviceId: window.ReactNativeProps?.deviceId,
    });
};
